interface HeroSectionProps {
  selectedCountry: string;
}

const countryData: Record<string, { name: string; tagline: string; keywords: string; image: string }> = {
  'saudi-arabia': {
    name: 'Saudi Arabia',
    tagline: 'Spiritual Journeys & Modern Wonders',
    keywords: 'Umrah • Hajj • Riyadh • AlUla • Red Sea',
    image: 'https://public.readdy.ai/ai/img_res/b73c05e2d1254e13e8869f7d4781cbee.jpg'
  },
  'turkey': {
    name: 'Turkey',
    tagline: 'Where East Meets West',
    keywords: 'Istanbul • Cappadocia • Antalya • Turkish Riviera • Hot Air Balloons',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20panoramic%20view%20of%20Istanbul%20Turkey%20at%20golden%20sunset%20featuring%20the%20iconic%20Blue%20Mosque%20and%20Hagia%20Sophia%20with%20their%20majestic%20domes%20and%20minarets%20silhouetted%20against%20warm%20orange%20and%20pink%20sky%20overlooking%20the%20shimmering%20Bosphorus%20strait%20with%20traditional%20Ottoman%20architecture%20and%20historic%20cityscape%20blending%20European%20and%20Asian%20cultures&width=1920&height=600&seq=turkey-hero-001&orientation=landscape'
  },
  'uae': {
    name: 'United Arab Emirates',
    tagline: 'Luxury Meets Tradition',
    keywords: 'Dubai • Abu Dhabi • Burj Khalifa • Desert Safari • Modern Luxury',
    image: 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20view%20of%20Dubai%20UAE%20skyline%20at%20golden%20hour%20featuring%20the%20iconic%20Burj%20Khalifa%20towering%20above%20futuristic%20skyscrapers%20and%20modern%20architecture%20with%20the%20shimmering%20Persian%20Gulf%20coastline%20luxury%20marina%20and%20golden%20desert%20dunes%20in%20the%20background%20under%20warm%20amber%20and%20purple%20sunset%20sky%20representing%20Arabian%20luxury%20and%20innovation&width=1920&height=600&seq=uae-hero-001&orientation=landscape'
  },
  'morocco': {
    name: 'Morocco',
    tagline: 'Imperial Cities & Desert Dreams',
    keywords: 'Marrakesh • Fes • Sahara • Chefchaouen • Atlas Mountains',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Marrakesh%20Morocco%20medina%20at%20golden%20sunset%20hour%20featuring%20the%20iconic%20Koutoubia%20Mosque%20minaret%20rising%20above%20traditional%20terracotta%20rooftops%20and%20ancient%20riads%20with%20narrow%20winding%20streets%20of%20the%20old%20city%20surrounded%20by%20palm%20trees%20and%20distant%20Atlas%20Mountains%20under%20warm%20amber%20and%20orange%20sky%20showcasing%20authentic%20Moroccan%20Islamic%20architecture&width=1920&height=600&seq=morocco-hero-001&orientation=landscape'
  },
  'egypt': {
    name: 'Egypt',
    tagline: 'Ancient Wonders & Red Sea Shores',
    keywords: 'Pyramids • Nile Cruise • Luxor • Red Sea • Cairo',
    image: 'https://readdy.ai/api/search-image?query=Majestic%20view%20of%20the%20Great%20Pyramids%20of%20Giza%20Egypt%20at%20golden%20hour%20with%20the%20iconic%20Sphinx%20in%20foreground%20ancient%20limestone%20structures%20rising%20from%20golden%20desert%20sands%20under%20warm%20amber%20and%20orange%20sunset%20sky%20with%20dramatic%20clouds%20showcasing%20timeless%20Egyptian%20civilization%20and%20archaeological%20wonders%20of%20the%20ancient%20world&width=1920&height=600&seq=egypt-hero-001&orientation=landscape'
  },
  'jordan': {
    name: 'Jordan',
    tagline: 'Rose City & Desert Landscapes',
    keywords: 'Petra • Wadi Rum • Dead Sea • Jerash • Amman',
    image: 'https://readdy.ai/api/search-image?query=Breathtaking%20view%20of%20the%20iconic%20Treasury%20Al-Khazneh%20in%20Petra%20Jordan%20carved%20into%20rose-red%20sandstone%20cliff%20face%20with%20intricate%20Nabataean%20architecture%20and%20classical%20columns%20framed%20by%20dramatic%20narrow%20canyon%20walls%20of%20the%20Siq%20under%20warm%20golden%20sunlight%20highlighting%20the%20ancient%20archaeological%20wonder%20and%20UNESCO%20World%20Heritage%20site&width=1920&height=600&seq=jordan-hero-001&orientation=landscape'
  },
  'malaysia': {
    name: 'Malaysia',
    tagline: 'Halal Food Capital & Tropical Paradise',
    keywords: 'Kuala Lumpur • Langkawi • Penang • Halal Dining • Family Beaches',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20panoramic%20view%20of%20Kuala%20Lumpur%20Malaysia%20skyline%20at%20golden%20sunset%20featuring%20the%20iconic%20Petronas%20Twin%20Towers%20illuminated%20against%20warm%20orange%20and%20purple%20sky%20with%20modern%20skyscrapers%20lush%20tropical%20greenery%20and%20the%20beautiful%20Sultan%20Abdul%20Samad%20Building%20showcasing%20Islamic%20Moorish%20architecture%20blending%20contemporary%20and%20traditional%20Malaysian%20culture&width=1920&height=600&seq=malaysia-hero-001&orientation=landscape'
  },
  'indonesia': {
    name: 'Indonesia',
    tagline: 'Tropical Islands & Muslim Heritage',
    keywords: 'Lombok • Jakarta • Halal Resorts • Pristine Beaches • Mount Rinjani',
    image: 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20view%20of%20pristine%20tropical%20beach%20in%20Lombok%20Indonesia%20with%20crystal%20clear%20turquoise%20waters%20white%20sandy%20shore%20traditional%20wooden%20boats%20and%20lush%20green%20palm%20trees%20with%20majestic%20Mount%20Rinjani%20volcano%20in%20the%20background%20under%20bright%20blue%20sky%20showcasing%20untouched%20natural%20beauty%20and%20Muslim-majority%20island%20paradise&width=1920&height=600&seq=indonesia-hero-001&orientation=landscape'
  },
  'maldives': {
    name: 'Maldives',
    tagline: 'Luxury Overwater Villas & Halal Resorts',
    keywords: 'Overwater Bungalows • Halal-Certified • Private Islands • Marine Life • Family Luxury',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20luxury%20overwater%20villas%20and%20bungalows%20in%20the%20Maldives%20with%20wooden%20walkways%20extending%20over%20crystal%20clear%20turquoise%20lagoon%20waters%20surrounded%20by%20pristine%20white%20sandy%20beaches%20and%20vibrant%20coral%20reefs%20under%20bright%20blue%20sky%20with%20fluffy%20white%20clouds%20showcasing%20tropical%20island%20paradise%20and%20exclusive%20halal-friendly%20resort%20luxury&width=1920&height=600&seq=maldives-hero-001&orientation=landscape'
  },
  'bosnia': {
    name: 'Bosnia & Herzegovina',
    tagline: 'European Muslim Heritage & Natural Beauty',
    keywords: 'Sarajevo • Mostar Bridge • Ottoman History • Halal Europe • Affordable Family Travel',
    image: 'https://readdy.ai/api/search-image?query=Picturesque%20view%20of%20the%20iconic%20Stari%20Most%20Old%20Bridge%20in%20Mostar%20Bosnia%20and%20Herzegovina%20spanning%20the%20emerald%20green%20Neretva%20River%20with%20traditional%20Ottoman%20stone%20architecture%20historic%20buildings%20with%20red%20terracotta%20roofs%20and%20mosque%20minarets%20surrounded%20by%20lush%20green%20mountains%20under%20bright%20blue%20sky%20showcasing%20European%20Muslim%20heritage%20and%20Balkan%20beauty&width=1920&height=600&seq=bosnia-hero-001&orientation=landscape'
  }
};

export default function HeroSection({ selectedCountry }: HeroSectionProps) {
  const data = countryData[selectedCountry] || countryData['saudi-arabia'];

  return (
    <div className="relative h-[600px] w-full overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${data.image}')` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      
      <div className="relative h-full flex items-center justify-center text-center px-6">
        <div className="max-w-4xl w-full">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 drop-shadow-lg">
            {data.name}
          </h1>
          <p className="text-2xl md:text-3xl text-white/95 mb-6 font-light drop-shadow-md">
            {data.tagline}
          </p>
          <div className="inline-block bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full mb-8">
            <p className="text-white/90 text-sm md:text-base font-medium">
              {data.keywords}
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="#accommodations"
              className="px-8 py-4 bg-[#C9A961] text-white rounded-full font-semibold hover:bg-[#B8954E] transition-all shadow-lg cursor-pointer whitespace-nowrap"
            >
              Explore {data.name}
            </a>
            <a
              href="/contact"
              className="px-8 py-4 bg-white text-gray-900 rounded-full font-semibold hover:bg-gray-100 transition-all shadow-lg cursor-pointer whitespace-nowrap"
            >
              Get a Free Quote
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}